<template>
  <div v-if="isLoading" class="global-loader-overlay">
    <div class="global-loader-content">
      <wifi-loader />
    </div>
  </div>
</template>

<script>
  import WifiLoader from './wifi-loading.vue'

  export default {
    name: 'GlobalLoader',
    components: {
      WifiLoader,
    },
    data() {
      return {
        isLoading: false,
      }
    },
    mounted() {
      // Listen for global loader events
      this.$eventHub.$on('showGlobalLoader', this.showLoader)
      this.$eventHub.$on('hideGlobalLoader', this.hideLoader)
    },
    beforeDestroy() {
      // Clean up event listeners
      this.$eventHub.$off('showGlobalLoader', this.showLoader)
      this.$eventHub.$off('hideGlobalLoader', this.hideLoader)
    },
    methods: {
      showLoader() {
        this.isLoading = true
      },
      hideLoader() {
        this.isLoading = false
      },
    },
  }
</script>

<style scoped>
  .global-loader-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    backdrop-filter: blur(2px);
  }

  .global-loader-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: white;
  }

  .global-loader-content .wifi-symbol {
    display: block !important;
    position: relative !important;
    top: 0 !important;
    left: 0 !important;
    transform: none !important;
    width: 80px !important;
    height: 80px !important;
    margin-bottom: 20px;
  }

  .global-loader-content .wifi-symbol .wifi-circle {
    border-color: #fff !important;
  }

  .connecting-text {
    font-size: 18px;
    font-weight: 500;
    margin: 0;
    color: white;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
  }
</style>
